// Consumer hooks for feature flags. Both are fail-closed: with no provider in
// the tree they behave as if flags are unavailable and default-OFF.

import { useContext } from 'react'
import { FlagsContext, type FlagsStatus } from './FlagsProvider'
import type { FlagKey } from './types'

/**
 * Returns whether `key` is enabled. Fail-closed: `false` when the provider is
 * absent, the initial fetch has not resolved, the key is unknown, or resolution
 * failed. Only a value the backend reported as `true` yields `true`.
 */
export function useFeatureFlag(key: FlagKey): boolean {
  const ctx = useContext(FlagsContext)
  if (!ctx) return false
  return ctx.flags[key] === true
}

/**
 * Returns the lifecycle of the flag fetch for optional UI. `'error'` when no
 * provider is mounted (flags cannot resolve).
 */
export function useFlagsStatus(): FlagsStatus {
  const ctx = useContext(FlagsContext)
  if (!ctx) return 'error'
  return ctx.status
}
